export const ADMIN_ROLE = 8;
export const POSTULANTE_ROLE = 9;
export const OPERACIONES_ROLE = 14;

const normalizePath = (value) => {
  const path = String(value || "").toLowerCase().trim();
  if (!path || path === "/") {
    return "/";
  }

  return path.endsWith("/") ? path.slice(0, -1) : path;
};

export const decodeTokenPayload = (token) => {
  if (!token) return null;

  try {
    const payload = token.split(".")[1];
    if (!payload) return null;

    return JSON.parse(window.atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
  } catch {
    return null;
  }
};

export const getRoleFromToken = (token) => {
  const payload = decodeTokenPayload(token);
  const roleValue =
    payload?.role
    || payload?.Role
    || payload?.["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

  const roleNumber = Number(roleValue);
  return Number.isFinite(roleNumber) ? roleNumber : null;
};

export const canManageOperacionesImportacion = (role) => (
  role === ADMIN_ROLE || role === OPERACIONES_ROLE
);

export const isOperacionesImportacionPath = (path) => {
  const normalized = normalizePath(path);
  return normalized === "/administracion/importacion-operaciones"
    || normalized === "/administracion/conciliacion-operaciones";
};

export const isAdministrativePath = (path) => {
  const normalized = normalizePath(path);
  return normalized.startsWith("/administracion") || normalized.startsWith("/admin");
};

export const getOperacionesRedirectPath = (path, role) => {
  if (role !== OPERACIONES_ROLE) {
    return null;
  }

  if (isAdministrativePath(path) && !isOperacionesImportacionPath(path)) {
    return "/administracion/importacion-operaciones";
  }

  return null;
};
